import { Component, OnInit} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/Core/services/user.service';

interface device_data {
  platform: string; 
  platform_version: string; 
  app_device: string;
  app_version: string;
}

@Component({
  selector: 'app-device-type',
  templateUrl: './device-type.component.html',
  styleUrls: ['./device-type.component.css']
})
export class DeviceTypeComponent {
  filteredDevices: any;
  public user: any;
  userID: string;
  deviceTypesToggle: boolean = true;
  
  constructor(private http: HttpClient, private router: Router, private route: ActivatedRoute, private userService: UserService) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.userID = params.get('id') || '';
      this.fetchUserData();
    });
  }

  fetchUserData() {
    this.userService.getUserDataByUserID(this.userID).subscribe(
      (data) => {
        this.user = data;
      },
      (error) => {
        console.error('Error fetching user data:', error);
      }
    );
  }

  getFilteredDeviceTypes(): any {
    this.filteredDevices = this.user?.device_types?.filter((device: device_data) => device.platform || device.platform_version || device.app_device) || [];
    return this.filteredDevices
  }
}
